import { defineStore } from 'pinia';
import router from '@/router';
import authService from '@/services/authService';
import driversService from '@/services/driversService';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isAuthenticated: false,
    user: {
      uid: '',
      firstName: '',
      lastName: '',
      username: '',
      role: '',
      hasLoggedInBefore: '',
    },
    expirationTime: null,
    driverStatus: null
  }),
  actions: {
    login(user) {
      console.log('Logowanie użytkownika:', user);
      this.isAuthenticated = true;
      this.user = user;

      const expirationTime = new Date().getTime() + 60 * 60 * 1000 * 24; //TODO
      this.expirationTime = expirationTime;
      localStorage.setItem('expirationTime', expirationTime);

      console.log(`Ustawiono expirationTime na: ${new Date(expirationTime).toLocaleString()}`);
    },

    async logout(callAuthService) {
      console.log('Wylogowywanie użytkownika...');
      try {

        if(this.user.role == 'ROLE_DRIVER') {
          driversService.updateDriverStatus(this.user.uid);
        }

        if (callAuthService) {
          await authService.logout();
        }
        
        this.clearAllCookies();
        localStorage.clear();
    
        this.isAuthenticated = false;
        this.user = { uid: '', firstName: '', lastName: '', username: '', role: '', firstLogin: '' };
        this.expirationTime = null;
        this.driverStatus = null;
    
        router.push('/login');
        console.log('Użytkownik został wylogowany i przekierowany na stronę logowania.');
      } catch (error) {
        console.error('Błąd podczas wylogowywania:', error);
      }
    },

    async fetchDriverData(uid) {
      try {
        const response = await driversService.getDriverById(uid);
        this.driverStatus = response.data.driverStatus;
      } catch (error) {
        console.error('Błąd podczas pobierania danych kierowcy:', error);
      }
    },

    checkExpiration() {
      console.log('Sprawdzanie wygaśnięcia sesji...');
      const storedExpirationTime = localStorage.getItem('expirationTime');
      const now = new Date().getTime();
      const expirationTime = Number(storedExpirationTime);
    
      if (isNaN(expirationTime)) {
        console.error('Nieprawidłowy czas wygaśnięcia w localStorage');
        return;
      }
    
      console.log(`Bieżący czas: ${new Date(now).toLocaleString()}, expirationTime: ${new Date(expirationTime).toLocaleString()}`);
    
      if (expirationTime && now > expirationTime) {
        console.log("Sesja wygasła. Wylogowywanie użytkownika...");
        this.logout(true);
      } else {
        // Obliczanie pozostałego czasu do wygaśnięcia sesji
        const remainingTime = expirationTime - now;
        const remainingMinutes = Math.floor(remainingTime / 60000); // pozostałe minuty
        const remainingSeconds = Math.floor((remainingTime % 60000) / 1000); // pozostałe sekundy
    
        console.log(`Pozostały czas sesji: ${remainingMinutes} minut i ${remainingSeconds} sekund.`);
      }
    },
    
    clearSessionAndCookies() {
        this.clearAllCookies();
        localStorage.clear();
    
        this.isAuthenticated = false;
        this.user = { uid: '', firstName: '', lastName: '', username: '', role: '', firstLogin: '' };
        this.expirationTime = null;
        this.driverStatus = null;
    },

    clearAllCookies() {
      console.log('Czyszczenie wszystkich ciasteczek...');
      const cookies = document.cookie.split(";");

      for (let cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        console.log(`Usunięto ciasteczko: ${name}`);
      }

      document.cookie = "accessToken=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=localhost";
      console.log('Usunięto ciasteczko accessToken.');
    },

    startSessionCheck() {
      console.log('Rozpoczęcie cyklicznego sprawdzania sesji...');
      this.checkExpiration();

      this.checkExpirationInterval = setInterval(() => {
        console.log('Cykliczne sprawdzanie sesji...');
        this.checkExpiration();
      }, 1 * 60 * 1000);
    },

    stopSessionCheck() {
      if (this.checkExpirationInterval) {
        clearInterval(this.checkExpirationInterval);
        console.log('Zatrzymano cykliczne sprawdzanie sesji.');
      }
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'auth',
        storage: localStorage,
      }
    ]
  }
});
